export const ICON_GROUPS: Record<string, string[]> = {
  alerts: [
    'fas fa-check-circle',
    'fas fa-flag',
    'fas fa-radiation',
    'fas fa-exclamation-circle',
    'fas fa-comment-exclamation',
    'fas fa-bell-on',
    'fas fa-alarm-exclamation',
    'far fa-calendar-exclamation',
  ],

  arrows: [
    'fas fa-sync',
    'fas fa-share-all',
    'fas fa-inbox-out',
    'fas fa-inbox-in',
    'fas fa-cloud-upload-alt',
    'fas fa-cloud-download-alt',
    'fas fa-cart-arrow-down',
  ],

  audioVideo: [
    'fas fa-tv-alt',
    'fas fa-stop-circle',
    'fas fa-rss',
    'fas fa-projector',
    'fas fa-podcast',
    'fas fa-play-circle',
    'fas fa-photo-video',
    'fas fa-pause-circle',
    'far fa-waveform-path',
  ],

  business: [
    'fas fa-thumbtack',
    'fas fa-tasks-alt',
    'fas fa-tasks',
    'fas fa-tags',
    'fas fa-sitemap',
    'fas fa-print',
    'fas fa-phone-alt',
    'fas fa-pencil',
    'fas fa-paperclip',
    'fas fa-folders',
    'fas fa-folder-open',
    'fas fa-file-alt',
    'fas fa-envelope',
    'fas fa-chart-line',
    'fas fa-chart-bar',
    'fas fa-calendar',
    'fas fa-bullseye',
    'fas fa-birthday-cake',
    'fas fa-badge-dollar',
  ],

  chat: [
    'fas fa-sms',
    'fas fa-smile',
    'fas fa-quote-right',
    'fas fa-poo',
    'fas fa-phone-slash',
    'fas fa-phone-plus',
    'fas fa-comments',
    'fas fa-comment-plus',
    'fas fa-comment-check',
    'fas fa-at',
    'fas fa-mobile-android-alt',
    'fas fa-paper-plane',
    'far fa-webcam',
  ],

  dateTime: [
    'fas fa-watch',
    'fas fa-stopwatch',
    'fas fa-snooze',
    'fas fa-hourglass-start',
    'fas fa-clock',
    'fas fa-calendar-times',
    'fas fa-calendar-check',
    'far fa-calendar-exclamation',
    'far fa-calendar-alt',
  ],

  energy: [
    'fas fa-sun',
    'fas fa-power-off',
    'fas fa-plug',
    'fas fa-lightbulb',
    'fas fa-fire-alt',
    'fas fa-battery-three-quarters',
  ],

  files: [
    'far fa-file-word',
    'far fa-file-video',
    'far fa-file-times',
    'far fa-file-search',
    'far fa-file-powerpoint',
    'far fa-file-pdf',
    'far fa-file-exclamation',
    'far fa-file-excel',
    'far fa-file-check',
  ],

  finance: [
    'fas fa-stamp',
    'fas fa-sack-dollar',
    'fas fa-money-bill',
    'fas fa-hand-holding-usd',
    'fas fa-file-invoice-dollar',
    'fas fa-donate',
    'fas fa-comments-dollar',
  ],

  medical: [
    'fas fa-user-md',
    'fas fa-tooth',
    'fas fa-prescription-bottle-alt',
    'fas fa-prescription',
    'fas fa-hospital-symbol',
    'fas fa-heartbeat',
    'fas fa-heart',
  ],

  /* brands: [
      'fab fa-youtube',
      'fab fa-windows',
      'fab fa-whatsapp',
      'fab fa-vimeo-square',
      'fab fa-usps',
      'fab fa-ups',
      'fab fa-twitter-square',
      'fab fa-trello',
      'fab fa-tiktok',
      'fab fa-telegram',
      'fab fa-stripe-s',
      'fab fa-snapchat-square',
      'fab fa-slack',
      'fab fa-skype',
      'fab fa-salesforce',
      'fab fa-safari',
      'fab fa-linkedin',
      'fab fa-intercom',
      'fab fa-instagram',
      'fab fa-hubspot',
      'fab fa-google',
      'fab fa-fedex',
      'fab fa-facebook',
      'fab fa-dropbox',
      'fab fa-chrome',
    ], */
};

export const ICONS_FLAT = Object.values(ICON_GROUPS).flat();
